/**
 * Notification type constants — match backend NotificationType enum.
 * Use these when mapping notification clicks to routes.
 */
export const NOTIFICATION_TYPES = {
  VENDOR_FIRST_LOGIN: 'VENDOR_FIRST_LOGIN',
  VENDOR_ONBOARDING_COMPLETED: 'VENDOR_ONBOARDING_COMPLETED',
  NEW_PROMOTER_VERIFIED: 'NEW_PROMOTER_VERIFIED',
  NEW_PROSPECT_VERIFIED: 'NEW_PROSPECT_VERIFIED',
  REVIEW_PUBLISHED: 'REVIEW_PUBLISHED',
  TESTIMONIAL_REQUESTED: 'TESTIMONIAL_REQUESTED',
  TESTIMONIAL_SUBMITTED: 'TESTIMONIAL_SUBMITTED',
  TESTIMONIAL_APPROVED: 'TESTIMONIAL_APPROVED',
  TESTIMONIAL_REJECTED: 'TESTIMONIAL_REJECTED',
  MEETING_SCHEDULED: 'MEETING_SCHEDULED',
  MEETING_ACCEPTED: 'MEETING_ACCEPTED',
  MEETING_RESCHEDULED: 'MEETING_RESCHEDULED',
  MEETING_STARTED: 'MEETING_STARTED',
  MEETING_ENDED: 'MEETING_ENDED',
  MEETING_COMING_SOON: 'MEETING_COMING_SOON',
  MEETING_CANCELLED: 'MEETING_CANCELLED',
  MEETING_PARTICIPANT_JOINED: 'MEETING_PARTICIPANT_JOINED',
  PROSPECT_FINALIZED: 'PROSPECT_FINALIZED',
  PROMOTER_DEMO_REQUESTED: 'PROMOTER_DEMO_REQUESTED',
  FUND_REQUEST_CREATED: 'FUND_REQUEST_CREATED',
  REFERRAL_CREATED: 'REFERRAL_CREATED',
  REFERRAL_ASSIGNED: 'REFERRAL_ASSIGNED',
  SURVEY_RESPONSE_RECEIVED: 'SURVEY_RESPONSE_RECEIVED',
  DISCOUNT_REWARD_ISSUED: 'DISCOUNT_REWARD_ISSUED',
  SPECIFIC_REWARD_CREATED: 'SPECIFIC_REWARD_CREATED',
  SPECIFIC_REWARD_COMPLETED: 'SPECIFIC_REWARD_COMPLETED',
  SPECIFIC_REWARD_CLAIMED: 'SPECIFIC_REWARD_CLAIMED',
  SPECIFIC_REWARD_PAID: 'SPECIFIC_REWARD_PAID',
  SPECIFIC_REWARD_REMINDER: 'SPECIFIC_REWARD_REMINDER',
  GIFT_CARD_REWARD_PENDING: 'GIFT_CARD_REWARD_PENDING',
  GIFT_CARD_REWARD_PAID: 'GIFT_CARD_REWARD_PAID',
  GIFT_CARD_REWARD_FAILED: 'GIFT_CARD_REWARD_FAILED',
  REWARD_CHOICE_PENDING: 'REWARD_CHOICE_PENDING',
  INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
} as const;
